import React from 'react';
import imgStars from '../../assets/stars.webp';  // Assuming you have a stars image
import imgUser from '../../assets/user.webp';   // Assuming you have a user image

const Review = () => {
    return (
        <>
            <div class="testimonial-section">
                <div class="container">
                    <h5 class="section-head head-review-copy">Aussie Pools Love It</h5>
                    <div class="row py10 pad-web">
                        <div class="col-md-6 col-lg-4 ">
                            <div class="card-testimonial">
                                <img src={imgStars} alt="Stars" class="star-img" />
                                <h4 class="testimonial-head pe-2">Saved $200 - Pool’s perfect!</h4>
                                <div class="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" class="user-img" />
                                    <span class="user-name">– @JohnGC76</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <div class="card-testimonial">
                                <img src={imgStars} alt="Stars" class="star-img" />
                                <h4 class="testimonial-head pe-2">Green to clean in a day!</h4>
                                <div class="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" class="user-img" />
                                    <span class="user-name">– @ShazPerth</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 ">
                            <div class="card-testimonial">
                                <img src={imgStars} alt="Stars" class="star-img" />
                                <h4 class="testimonial-head pe-2">HelpBot fixed my pH at 2am.</h4>
                                <div class="align-items-center d-flex gap10">
                                    <img src={imgUser} alt="User" class="user-img" />
                                    <span class="user-name">– @DaveSyd73</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h6 class="trusted-pool">Trusted by 800+ Pool Owners</h6>
                        <div class="text-center">
                            <button class="btn trusted-btn landing-slider-button">See Why — Start Your Free Trial</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Review;
